module.exports = __webpack_public_path__ + "static/media/conference-catering-3.ba72dce6.jpg";